import api from '../../api'
import {SERVICE_GROUP_CREATE, SERVICE_GROUP_UPDATE, SERVICE_GROUP_DELETE} from '../mutations/available'
import {showApiError} from '../../helpers/notification'
import store from '../index'

export const serviceGroupsCreate = async ({commit, dispatch, state}, serviceGroup) => {
  let createdServiceGroup = null
  try {
    createdServiceGroup = await api.createServiceGroup(serviceGroup)
    commit(SERVICE_GROUP_CREATE, createdServiceGroup)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create service group')
    console.log(`Unable to create service group, details: ${JSON.stringify(e)}`)

    throw e
  }

  return createdServiceGroup
}

export const serviceGroupsUpdate = async ({commit, dispatch, state}, serviceGroup) => {
  let updatedServiceGroup = null
  try {
    updatedServiceGroup = await api.updateServiceGroup(serviceGroup)
    commit(SERVICE_GROUP_UPDATE, updatedServiceGroup)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update service group')
    console.log(`Unable to update service group, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updatedServiceGroup
}

export const serviceGroupsDelete = async ({commit, dispatch, state}, serviceGroup) => {
  try {
    await api.deleteServiceGroup(serviceGroup)
    commit(SERVICE_GROUP_DELETE, serviceGroup)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete service group')
    console.log(`Unable to delete service group, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}



// WEBPACK FOOTER //
// ./src/store/actions/service-groups.js